import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetResources = () => {
  const get = useTypedApiClient({
    path: '/le-connect/resources',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/le-connect/resources'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
